module.exports = __webpack_public_path__ + "static/media/pen-edit.29f36af5.svg";